import {ROUTES} from 'common/domain/routes';

const INCEPTION = {
  DESKTOP: `${ROUTES.VACATIONS_ABSENCES.ROOT}${ROUTES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR}`,
  MOBILE: `${ROUTES.VACATIONS_ABSENCES.ROOT}${ROUTES.VACATIONS_ABSENCES.EMPLOYEE_CALENDAR_MOBILE}`
};

class InceptionService {
  constructor($location, $window) {
    'ngInject';
    this.location = $location;
    this.isMobileApp = $window.innerWidth < 1024;
  }

  incept(employeeId, from) {
    let url = this.getUrl();
    url = this.setEmployeeId(url, employeeId);
    url = this.setFrom(url, from);
    this.location.url(url);
  }

  getUrl() {
    const url = this.isMobileApp ? INCEPTION.MOBILE : INCEPTION.DESKTOP;
    return url;
  }

  setEmployeeId(url, employeeId) {
    return url.replace(':employeeId', employeeId);
  }

  setFrom(url, from) {
    if (from) {
      url += '=' + from;
    }

    return url;
  }
}

export default InceptionService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/services/inception.service.js